import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TreeViewContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TreeViewContext.displayName = 'TreeViewContext';
}

export default TreeViewContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TreeView/TreeViewContext.js
// module id = 904
// module chunks = 2